import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotAvailable = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 177,
	height: 177,
	viewBox: "0 0 177 177",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_3426_10781)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M89 177C137.877 177 177.5 137.377 177.5 88.5C177.5 39.6228 137.877 0 89 0C40.1228 0 0.5 39.6228 0.5 88.5C0.5 137.377 40.1228 177 89 177Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M126.482 148.888H52.5588C51.4088 148.888 50.4765 149.821 50.4765 150.971C50.4765 152.121 51.4088 153.053 52.5588 153.053H126.482C127.632 153.053 128.565 152.121 128.565 150.971C128.565 149.821 127.632 148.888 126.482 148.888Z",
					fill: "#F2F2F2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M112.697 97.0794H66.3441V104.909H112.697V97.0794Z",
					fill: "#B8B8B8",
					stroke: "#686868",
					strokeWidth: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M98.3706 105.159L109.824 116.612V114.529L100.453 105.159H98.3706Z",
					fill: "#686868"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M77.5471 105.159L68.1765 114.529V116.612L79.6294 105.159H77.5471Z",
					fill: "#686868"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M56.9735 101.785H121.026V95.1635C121.026 93.923 120.018 92.9147 118.776 92.9147H59.2244C57.9817 92.9147 56.9735 93.9218 56.9735 95.1635V101.785Z",
					fill: "#EBEBEB",
					stroke: "#686868",
					strokeWidth: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M61.1314 120.313C60.8604 119.961 60.698 119.535 60.6695 119.082L59.5808 101.785H68.4427L67.354 119.082C67.3255 119.535 67.1631 119.961 66.8921 120.313L66.6376 131.289C67.1071 131.691 67.3853 132.28 67.3853 132.914C67.3853 133.54 67.1155 134.121 66.6598 134.522C66.7938 134.804 66.8647 135.115 66.8647 135.435C66.8647 135.858 66.7414 136.263 66.5143 136.608L66.1996 150.179H61.824L61.5092 136.607C61.2822 136.262 61.1588 135.857 61.1588 135.435C61.1588 135.112 61.2308 134.799 61.3667 134.515C60.92 134.112 60.6616 133.532 60.673 132.91C60.6841 132.305 60.9473 131.741 61.3871 131.341L61.1314 120.313Z",
					fill: "#B8B8B8",
					stroke: "#686868",
					strokeWidth: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M101.244 81.4618H96.5382V93.4559H101.244V81.4618Z",
					fill: "#B8B8B8",
					stroke: "#686868",
					strokeWidth: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M81.4618 81.4618H76.7559V93.4559H81.4618V81.4618Z",
					fill: "#B8B8B8",
					stroke: "#686868",
					strokeWidth: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M75.3955 69.7589H102.136L88.3723 45.8348L75.3955 69.7589ZM84.601 28.7668C86.5214 25.2263 89.7056 25.1849 91.7098 28.6687L118.306 74.8992C120.311 78.3856 118.675 81.2118 114.646 81.2118H63.4452C59.4184 81.2118 57.7099 78.3432 59.6312 74.8012L84.601 28.7668Z",
					fill: "#686868"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M73.6099 70.7461H103.899L88.3092 43.6464L73.6099 70.7461ZM84.5646 28.7128C86.4851 25.1723 89.6693 25.131 91.6734 28.6147L118.269 74.8453C120.275 78.3316 118.639 81.1578 114.61 81.1578H63.4089C59.382 81.1578 57.6736 78.2892 59.5948 74.7472L84.5646 28.7128Z",
					fill: "#FF9B7E"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M84.5622 28.7128L59.5924 74.7472C57.6711 78.2892 59.3796 81.1578 63.4065 81.1578H114.607C118.636 81.1578 120.273 78.3316 118.267 74.8453L91.671 28.6147C89.6668 25.131 86.4826 25.1723 84.5622 28.7128ZM83.647 28.2164C85.955 23.9613 90.1623 23.9043 92.5735 28.0955L119.169 74.3261C121.575 78.5076 119.436 82.199 114.607 82.199H63.4065C58.5897 82.199 56.3799 78.486 58.6772 74.2508L83.647 28.2164Z",
					fill: "#686868"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M88.2119 33.0282L64.9001 76.0059H112.937L88.2119 33.0282ZM84.601 28.7668C86.5214 25.2263 89.7056 25.1849 91.7098 28.6687L118.306 74.8992C120.311 78.3856 118.675 81.2118 114.646 81.2118H63.4452C59.4184 81.2118 57.7099 78.3432 59.6312 74.8012L84.601 28.7668Z",
					fill: "#DD5100",
					fillOpacity: .3
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M111.063 120.253C110.819 119.913 110.673 119.509 110.646 119.082L109.557 101.785H118.419L117.331 119.082C117.302 119.535 117.14 119.961 116.869 120.313L116.614 131.289C117.084 131.691 117.362 132.28 117.362 132.914C117.362 133.54 117.092 134.121 116.636 134.522C116.77 134.804 116.841 135.115 116.841 135.435C116.841 135.858 116.718 136.263 116.491 136.608L116.176 150.179H111.801L111.466 136.576C111.251 136.238 111.135 135.844 111.135 135.435C111.135 135.112 111.207 134.799 111.343 134.515C110.896 134.112 110.638 133.532 110.649 132.91C110.66 132.317 110.913 131.764 111.337 131.365L111.063 120.253Z",
					fill: "#B8B8B8",
					stroke: "#686868",
					strokeWidth: .5
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_3426_10781",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 177,
				height: 177,
				fill: "white",
				transform: "translate(0.5)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgNotAvailable);
export default ForwardRef;
